export const statusStyles: Record<string, string> = {
  持续追踪: 'bg-primary-100 text-primary-800 border-primary-300/70',
  事件反转: 'bg-accent-100 text-accent-800 border-accent-300/70',
  已澄清: 'bg-secondary-100 text-secondary-800 border-secondary-300/70',
  待核实: 'bg-background-200 text-foreground-700 border-background-300',
  暂无后续: 'bg-background-200 text-foreground-600 border-background-300',
};

export const statusMark: Record<string, string> = {
  持续追踪: 'bg-primary-500',
  事件反转: 'bg-accent-500',
  已澄清: 'bg-secondary-500',
  待核实: 'bg-foreground-400',
  暂无后续: 'bg-foreground-300',
};

export const nodeStyles: Record<string, { chip: string; dot: string }> = {
  爆料: { chip: 'bg-accent-100 text-accent-800 border-accent-200', dot: 'bg-accent-500' },
  反转: { chip: 'bg-primary-100 text-primary-800 border-primary-200', dot: 'bg-primary-500' },
  回应: { chip: 'bg-secondary-100 text-secondary-800 border-secondary-200', dot: 'bg-secondary-500' },
  辟谣: { chip: 'bg-secondary-100 text-secondary-800 border-secondary-200', dot: 'bg-secondary-500' },
  官方: { chip: 'bg-background-200 text-foreground-800 border-background-300', dot: 'bg-foreground-700' },
};

export const getNodeStyle = (type: string) =>
  nodeStyles[type] ?? { chip: 'bg-background-200 text-foreground-800 border-background-300', dot: 'bg-foreground-600' };

export const getStatusStyle = (status: string) =>
  statusStyles[status] ?? 'bg-background-200 text-foreground-700 border-background-300';

export const getStatusMark = (status: string) => statusMark[status] ?? 'bg-foreground-400';

export const navSections = [
  { id: 'hot', label: '今日引爆' },
  { id: 'rank', label: '热搜追踪榜' },
  { id: 'archive', label: '反转档案' },
  { id: 'rumor', label: '辟谣专区' },
  { id: 'timeline', label: '最新时间线' },
  { id: 'faq', label: '常见问题' },
];